
import { useEffect, useRef } from 'react';

function MetricsStrip() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const items = entry.target.querySelectorAll('.metric-item');
            items.forEach((item, i) => {
              setTimeout(() => {
                item.classList.add('opacity-100', 'scale-100');
                item.classList.remove('opacity-0', 'scale-95');
              }, i * 100);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const metrics = [
    {
      direction: 'up',
      label: '30–50% Faster Lead Response',
    },
    {
      direction: 'up',
      label: 'Increased Conversion Efficiency',
    },
    {
      direction: 'down',
      label: 'Manual Administrative Load',
    },
    {
      direction: 'up',
      label: 'Operational Visibility',
    },
  ];

  return (
    <section className="relative py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f88f6d02a636fc8a2b455b55d335336a.jpg"
          alt="Metrics Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      <div ref={sectionRef} className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
          {metrics.map((metric, index) => (
            <div
              key={index}
              className="metric-item opacity-0 scale-95 transition-all duration-600 ease-out text-center"
            >
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-4 rounded-full bg-white/10">
                <i
                  className={`${
                    metric.direction === 'up' ? 'ri-arrow-up-line' : 'ri-arrow-down-line'
                  } text-lg text-[#2DD4BF]`}
                ></i>
              </div>
              <p className="text-sm font-medium text-white/90 leading-relaxed">
                {metric.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MetricsStrip;
